import requestv2 from "~/utils/http-v2";

const papersApi = {
	gets : async (params) => {
		const url = 'v2/papers';
		return await requestv2.get(url, {params});
	},
	count : async (params) => {
		const url = 'v2/papers/count';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/papers';
		return await requestv2.post(url, params);
	},
	status : async (params) => {
		const url = `v2/papers/status/${params.id}`;
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/papers/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete : async (id) => {
		const url = `v2/papers/${id}`;
		return await requestv2.delete(url);
	},
	getsType : async (params) => {
		const url = 'v2/papers/type';
		return await requestv2.get(url, {params});
	},
	addType : async (params) => {
		const url = 'v2/papers/type';
		return await requestv2.post(url, params);
	},
	updateType : async (params) => {
		const url = `v2/papers/type/${params.id}`;
		return await requestv2.patch(url, params);
	},
	importType : async (params) => {
		const url = 'v2/papers/type/import';
		return await requestv2.post(url, params);
	},
	deleteType : async (id) => {
		const url = `v2/papers/type/${id}`;
		return await requestv2.delete(url);
	},
	getsNumber : async (params) => {
		const url = 'v2/papers/number';
		return await requestv2.get(url, {params});
	},
	updateNumber : async (params) => {
		const url = `v2/papers/number/${params.id}`;
		return await requestv2.patch(url, params);
	},
	reCallNumber : async (params) => {
		const url = `v2/papers/number/re-call/${params.id}`;
		return await requestv2.post(url, params);
	},
	receiveNumber : async (params) => {
		const url = `v2/papers/number/receive/${params.id}`;
		return await requestv2.post(url, params);
	},
	cancelNumber : async (params) => {
		const url = `v2/papers/number/cancel/${params.id}`;
		return await requestv2.post(url, params);
	},
};

export default papersApi;